import { NgModule } from '@angular/core'

import { CommonModule } from '@angular/common'
import { VideoPreviewComponent } from './video-preview.component'
import { FloMseModule } from 'src/app/hls/mse.module'
import { FloHlsModule } from 'src/app/hls/hls.module'

// tslint:disable-next-line:readonly-array

@NgModule({
  imports: [
    CommonModule,
    FloMseModule,
    FloHlsModule.config({
      hlsConfig: {
        capLevelToPlayerSize: true // this module defaults to responsive renditions
      }
    })
  ],
  declarations: [VideoPreviewComponent],
  exports: [VideoPreviewComponent]
})
export class VideoPreviewModule {}
